module.exports = __webpack_public_path__ + "img/c4afa03.svg";